const SECTION_BY_USER_TYPE = {
  guest: 'navbar_guest',
  user: 'navbar_customer',
  manager: 'navbar_manager',
};

export function getTrackingSection(userType) {
  return SECTION_BY_USER_TYPE[userType] ?? SECTION_BY_USER_TYPE.guest;
}
